<script setup lang="ts">
   import { useAuth0 } from '@auth0/auth0-vue';
   import useAuthStore from '~/stores/auth';
   import { computed } from 'vue';
   import { clearLoggedIn, clearPostLoginRedirect } from '~/composables/usePostLoginRedirect';
   //store
   const { user } = useAuthStore();
   //props
   const { location, hideButtonText } = defineProps<{
      hideButtonText?: boolean;
      location: 'mainNav' | 'userMenu';
   }>();

   const { logout } = useAuth0();

   const logoutRedirectUrl = computed(() => {
      if (user?.site_settings?.portal === 'uspa') {
         return 'https://members.uspolo.org/';
      }
      return window.location.origin;
   });
   const userLogout = () => {
      clearLoggedIn();
      clearPostLoginRedirect();
      logout({
         logoutParams: {
            returnTo: logoutRedirectUrl.value,
         },
      });
   };
</script>

<template>
   <Button
      @click="userLogout"
      v-if="location === 'userMenu'"
      class="w-full pl-4"
      title="Log out">
      <span class="pi pi-sign-out"></span>
      <span class="ml-2" v-if="!hideButtonText">Log Out</span>
   </Button>
   <a
      @click="userLogout"
      v-if="location === 'mainNav'"
      class="flex w-full cursor-pointer items-center justify-between border-b-[3px] border-transparent bg-transparent p-3 text-xs font-bold uppercase text-gray-400 hover:border-brand-primary hover:text-black">
      Log Out
   </a>
</template>

<style scoped></style>
